module.exports = __webpack_public_path__ + "static/media/bio_gross.e3926d3f.jpg";